import React from 'react';
import Box from '@mui/material/Box';

export default function CardItem(props) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
            boxShadow: '0 4px 4px 0 rgba(0,0,0,0.15)', bgcolor: '#EAEFF2',
            marginTop: '10px', borderRadius: '5px', width: '100%', padding: '5px 10px',
            ...(props.sx || {}) }} onClick={props.onClick}>
            { props.children }
        </Box>
    )
}
